export default {
    GET_ITEMS(state) {
        return state.quotes
    },
    GET_ITEM(state,id) {
      state.quotes.find((item) => item.id == id)
    }
}
